/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { EmailHandle } from "./EmailHandle";
import {
  EmailHandleFromJSON,
  EmailHandleFromJSONTyped,
  EmailHandleToJSON,
  EmailHandleToJSONTyped,
} from "./EmailHandle";

/**
 *
 * @export
 * @interface OutlookMessage
 */
export interface OutlookMessage {
  /**
   *
   * @type {string}
   * @memberof OutlookMessage
   */
  messageId: string;
  /**
   *
   * @type {string}
   * @memberof OutlookMessage
   */
  conversationId?: string | null;
  /**
   *
   * @type {string}
   * @memberof OutlookMessage
   */
  internetMessageId?: string | null;
  /**
   *
   * @type {string}
   * @memberof OutlookMessage
   */
  subject?: string | null;
  /**
   *
   * @type {EmailHandle}
   * @memberof OutlookMessage
   */
  from?: EmailHandle | null;
  /**
   *
   * @type {Array<EmailHandle>}
   * @memberof OutlookMessage
   */
  to: Array<EmailHandle>;
  /**
   *
   * @type {Array<EmailHandle>}
   * @memberof OutlookMessage
   */
  cc: Array<EmailHandle>;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof OutlookMessage
   */
  sentAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof OutlookMessage
   */
  bodyHtml?: string | null;
  /**
   *
   * @type {string}
   * @memberof OutlookMessage
   */
  preview?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof OutlookMessage
   */
  hasAttachments: boolean;
}

/**
 * Check if a given object implements the OutlookMessage interface.
 */
export function instanceOfOutlookMessage(
  value: object,
): value is OutlookMessage {
  if (!("messageId" in value) || value["messageId"] === undefined) return false;
  if (!("to" in value) || value["to"] === undefined) return false;
  if (!("cc" in value) || value["cc"] === undefined) return false;
  if (!("hasAttachments" in value) || value["hasAttachments"] === undefined)
    return false;
  return true;
}

export function OutlookMessageFromJSON(json: any): OutlookMessage {
  return OutlookMessageFromJSONTyped(json, false);
}

export function OutlookMessageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OutlookMessage {
  if (json == null) {
    return json;
  }
  return {
    messageId: json["messageId"],
    conversationId:
      json["conversationId"] == null ? undefined : json["conversationId"],
    internetMessageId:
      json["internetMessageId"] == null ? undefined : json["internetMessageId"],
    subject: json["subject"] == null ? undefined : json["subject"],
    from: json["from"] == null ? undefined : EmailHandleFromJSON(json["from"]),
    to: (json["to"] as Array<any>).map(EmailHandleFromJSON),
    cc: (json["cc"] as Array<any>).map(EmailHandleFromJSON),
    sentAt: json["sentAt"] == null ? undefined : json["sentAt"],
    bodyHtml: json["bodyHtml"] == null ? undefined : json["bodyHtml"],
    preview: json["preview"] == null ? undefined : json["preview"],
    hasAttachments: json["hasAttachments"],
  };
}

export function OutlookMessageToJSON(json: any): OutlookMessage {
  return OutlookMessageToJSONTyped(json, false);
}

export function OutlookMessageToJSONTyped(
  value?: OutlookMessage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    messageId: value["messageId"],
    conversationId: value["conversationId"],
    internetMessageId: value["internetMessageId"],
    subject: value["subject"],
    from: EmailHandleToJSON(value["from"]),
    to: (value["to"] as Array<any>).map(EmailHandleToJSON),
    cc: (value["cc"] as Array<any>).map(EmailHandleToJSON),
    sentAt: value["sentAt"],
    bodyHtml: value["bodyHtml"],
    preview: value["preview"],
    hasAttachments: value["hasAttachments"],
  };
}
